// extracted by mini-css-extract-plugin
export default {"color-fields":"ColorFields_color-fields__h8ldW","color-fields-title":"ColorFields_color-fields-title__FUd46"};